/* eslint-disable jsx-a11y/anchor-is-valid */
import {Column} from 'react-table'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {SelectWrapper, InputDateWrapper} from '../../../../../../components/UI/Form/Input'
import {Button, ButtonWrapper} from '../../../../../../components/UI/Button'
import {FC, useEffect, useMemo, useCallback} from 'react'
import {KTCard, KTSVG} from '../../../../../../../../_metronic/helpers'
import {FormProvider, useForm} from 'react-hook-form'
import {yupResolver} from '@hookform/resolvers/yup'
import {laundryBillingFilter} from '../../../../schema/laundryReport'
import {useLaundryFilter} from '../../../../hooks/useLaundryFilter'
import {
  LaundryBillingHystoryModel,
  LaundryFilterReportModel,
} from '../../../../features/laundryBilling/model/laundryBilling.model'
import {useCollaborator, useGuest, useTableMaster} from '../../../../hooks'
import {getLaundryGenerateBilling} from '../../../../services'
import {TabLavanderiaModel} from '../../../../../../models'
import {useLavanderia} from '../../../../../../hooks/useLavanderia'
import {getFormatDate} from '../../../../../../util/functions'
import {clearFields} from '../../../../../../util/functions'
interface FormattedDate {
  fecha: string
  tiempo: string
  fechaMin: string
}

const TableLaundryBilling: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const {currentTabItem, changeCurrentTabItem, isAllowed} = useLavanderia()

  const methods = useForm<LaundryFilterReportModel>({
    resolver: yupResolver(laundryBillingFilter),
  })
  const {
    typeLaundryOrder,
    typeResponsableOrder,
    getTypeResponsableOrderList,
    getTypeLaundryOrderList,
  } = useTableMaster()
  const {setValue, handleSubmit, reset, watch, setError} = methods
  const {company, client, site, getCompanyList, getClientList, getSiteList, handleClearList} =
    useLaundryFilter()
  const {collaborator, getUserCollaboratorList, handleClear} = useCollaborator()
  const {guest, getGuestsServiceList, handleClear: handleCleaGuest} = useGuest()

  const handleFilterClient = (e: any) => {
    let value = e.value
    getClientList(value)
    clearFields(setValue as any, setError as any, {
      cliente: '',
      clienteId: '',
      siteId: '',
      site: '',
      responsableId: '',
    })
    handleClearUsers()
  }
  const handleClearUsers = () => {
    handleClear()
    handleCleaGuest()
  }
  const handleFilterSite = (e: any) => {
    let value = e.value
    getSiteList(value)
    clearFields(setValue as any, setError as any, {
      siteId: '',
      site: '',
      responsableId: '',
    })
    handleClearUsers()
  }

  const handleFilterUser = () => {
    let typeResponsable = watch('servicioId') === 'ROPA OPERACIÓN' ? 'COLABORADOR' : 'HUÉSPED'
    let getTypeValue =
      typeResponsableOrder
        .filter((item) => item.value?.toString() === typeResponsable)[0]
        ?.value?.toString() ?? ''
    getUser(getTypeValue)
    setValue('tipoResponsable', getTypeValue)
  }
  const getUser = (type: string) => {
    if (type === 'HUÉSPED') {
      getGuestsServiceList({
        pageNumber: 1,
        size: 100,
        CompaniaId: watch('companiaId'),
        SiteId: watch('siteId'),
      })
    } else {
      getUserCollaboratorList({
        companiaId: watch('companiaId'),
        siteId: watch('siteId'),
      })
    }
  }
  const handleGetReponsable = (e: any) => {
    let name = e.label
    setValue('responsable', name)
  }

  const getLaundryList = useCallback(
    async (props: LaundryFilterReportModel = {}) => {
      setLoading(true)
      try {
        const response = await getLaundryGenerateBilling({...props}, pagination.currentPage)
        const dataInfo = response.data?.data || []
        setData(dataInfo)
        setPagination({
          ...pagination,
          totalResults: response.data.total,
        })
      } catch (error) {
        console.log(error)
      }
      setLoading(false)
    },
    [setLoading, setData, pagination.currentPage],
  )
  const handleViewPanel = (data: any) => {
    const getRow = data.row
    const getArrows = data.data
    const getData = getArrows[getRow.index]
    const obj: TabLavanderiaModel = {
      ...currentTabItem,
      showPanel: true,
      idToEdit: getData.id,
      content: {
        ...currentTabItem.content,
        detailPanel: 'tab-laundry-billing',
      },
      idToDelete: '',
    }
    changeCurrentTabItem(obj)
  }
  const handleGetSite = (e: any) => {
    if (watch('tipoResponsable')) getUser(watch('tipoResponsable') ?? '')
  }
  const columns: Column<LaundryBillingHystoryModel>[] = useMemo(
    () => [
      {
        Header: (props) => <KTableHeader tableProps={props} title='Compañía' />,
        accessor: 'compania',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Cliente' />,
        accessor: 'cliente',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Site' />,
        accessor: 'site',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de responsable' />,
        accessor: 'tipoResponsable',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Responsable' />,
        accessor: 'responsable',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Tipo de servicio' />,
        accessor: 'tipoServicio',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Descripción' />,
        accessor: 'descripcion',
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fecha de periodo de inicio' />,
        accessor: 'fechaPeriodoInicio',
        Cell: ({...props}) => {
          let dateCreation = props.data[props.row.index].fechaPeriodoInicio
            ? getFormatDate(props.data[props.row.index].fechaPeriodoInicio)
            : ''
          return (
            <span>
              {dateCreation
                ? `${(dateCreation as FormattedDate).fecha} ${
                    (dateCreation as FormattedDate).tiempo
                  }`
                : ''}
            </span>
          )
        },
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Fecha de periodo de fin' />,
        accessor: 'fechaPeriodoFin',
        Cell: ({...props}) => {
          let dateCreation = props.data[props.row.index].fechaPeriodoFin
            ? getFormatDate(props.data[props.row.index].fechaPeriodoFin)
            : ''
          return (
            <span>
              {dateCreation
                ? `${(dateCreation as FormattedDate).fecha} ${
                    (dateCreation as FormattedDate).tiempo
                  }`
                : ''}
            </span>
          )
        },
      },
      {
        Header: (props) => <KTableHeader tableProps={props} title='Ver' />,
        id: 'actions',
        Cell: ({...props}) => (
          <div className='d-flex'>
            {isAllowed('VER') && (
              <div
                className='d-flex justify-content-center flex-shrink-0'
                onClick={() => handleViewPanel(props)}
              >
                <a href='#' className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'>
                  <KTSVG path='/media/icons/duotune/general/gen004.svg' className='svg-icon-3' />
                </a>
              </div>
            )}
          </div>
        ),
      },
    ],
    [],
  )

  const onSubmit = (dataForm: LaundryFilterReportModel) => {
    const {fechaPeriodoInicio, fechaPeriodoFin} = dataForm
    getLaundryList({
      fechaPeriodoInicio: fechaPeriodoInicio ? new Date(fechaPeriodoInicio) : '',
      fechaPeriodoFin: fechaPeriodoFin ? new Date(fechaPeriodoFin) : '',
      ...dataForm,
    })
  }

  const handleResetForm = (): void => {
    reset()
    handleClearList()
    getCompanyList()
    getLaundryList()
    handleClear()
    handleCleaGuest()
  }
  useEffect(() => {
    getLaundryList()
  }, [pagination.currentPage])
  useEffect(() => {
    getCompanyList()
    getTypeResponsableOrderList()
    getTypeLaundryOrderList()
  }, [])
  const handleGetService = (e: any) => {
    handleFilterUser()
  }
  let dataUser = watch('servicioId') === 'ROPA OPERACIÓN' ? collaborator : guest
  return (
    <>
      <KTCard shadow className='m-5'>
        {isAllowed('BUSCAR_ENCABEZADO') && (
          <div className='p-8'>
            <FormProvider {...methods}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className='row'>
                  <div className='col-sm-12 col-lg-3'>
                    <SelectWrapper
                      labelText='Compañía'
                      name='companiaId'
                      data={company}
                      onChangeValue={handleFilterClient}
                      required
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <SelectWrapper
                      labelText='Cliente'
                      name='clienteId'
                      data={client}
                      disabled={client.length === 0}
                      onChangeValue={handleFilterSite}
                      required
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <SelectWrapper
                      labelText='Site'
                      name='siteId'
                      data={site}
                      disabled={site.length === 0}
                      onChangeValue={handleGetSite}
                      required
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <SelectWrapper
                      labelText='Tipo de Orden'
                      name='servicioId'
                      data={typeLaundryOrder}
                      onChangeValue={handleGetService}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <SelectWrapper
                      labelText='Tipo de responsable'
                      name='tipoResponsable'
                      data={typeResponsableOrder}
                      disabled={true}
                    />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <SelectWrapper
                      labelText='Responsable'
                      name='responsableId'
                      data={dataUser}
                      onChangeValue={handleGetReponsable}
                      disabled={dataUser.length === 0}
                    />
                  </div>

                  <div className='col-sm-12 col-lg-3'>
                    <InputDateWrapper labelText='Desde' name='fechaPeriodoInicio' required />
                  </div>
                  <div className='col-sm-12 col-lg-3'>
                    <InputDateWrapper labelText='Hasta' name='fechaPeriodoFin' required />
                  </div>
                </div>
                <ButtonWrapper className='sdx-white-bg overflow-visible justify-content-end'>
                  <Button label='Buscar' typeBtn='submit' />
                  <Button label='Limpiar' onClick={() => handleResetForm()} />
                </ButtonWrapper>
              </form>
            </FormProvider>
          </div>
        )}
        {isAllowed('LISTAR') && (
          <>
            {loading ? <KTableLoading title='Cargando...' /> : null}
            <KTable data={data} columns={columns} />
          </>
        )}
      </KTCard>
    </>
  )
}

const TableLaundryBillingWrapper = () => {
  return (
    <KTableProvider>
      <TableLaundryBilling />
    </KTableProvider>
  )
}

export {TableLaundryBillingWrapper}
